import { Link } from "react-router-dom";
import { Home, Phone } from "lucide-react";
import Seo from "@/components/Seo";
import { COMPANY } from "@/config/site";

const NotFound = () => (
  <>
    <Seo
      title="Page introuvable | ASTROLOG"
      description="La page demandée n'existe pas ou a été déplacée."
      noindex
    />
    <section className="brand-dark noise relative flex flex-1 items-center py-24" data-testid="notfound-page">
      <div className="mx-auto max-w-xl px-4 text-center">
        <p className="font-heading text-7xl font-bold text-accent">404</p>
        <h1 className="mt-4 font-heading text-2xl font-semibold text-[#FAFAF7]">
          Cette page a changé d'itinéraire
        </h1>
        <p className="mt-3 text-slate-400">
          La page que vous cherchez n'existe pas ou a été déplacée.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="inline-flex items-center gap-2 rounded-full bg-accent px-6 py-3 font-heading text-sm font-semibold text-white transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#EA580C]"
          >
            <Home className="h-4 w-4" /> Retour à l'accueil
          </Link>
          <a
            href={COMPANY.phoneHref}
            className="inline-flex items-center gap-2 rounded-full border border-white/25 px-6 py-3 font-heading text-sm font-semibold text-[#FAFAF7] transition-colors hover:bg-white/10"
          >
            <Phone className="h-4 w-4" /> {COMPANY.phone}
          </a>
        </div>
      </div>
    </section>
  </>
);

export default NotFound;
